import React from "react";

//importing components
import Navbar from "../Navbar/Navbar";

//importing styles
import styles from "./Layout.module.scss";

const Layout = ({ children }) => {
  return (
    <div className={styles.layout}>
      <Navbar />
      <div className={styles.layoutContainer}>{children}</div>
    </div>
  );
};

export default Layout;
